// src/monad/config.js

// 1. Network Details for Monad Testnet
export const MONAD_CHAIN_ID = '0x279f'; // 10143
export const MONAD_CHAIN_NAME = 'Monad Testnet';
export const MONAD_RPC_URL = 'https://testnet-rpc.monad.xyz/';
export const MONAD_EXPLORER_URL = 'https://testnet.monadexplorer.com/';

// 2. SMART CONTRACT ADDRESSES
// ⚠️ CRITICAL: Replace these with the addresses you copied from Remix earlier!
export const CONTRACTS = {
  // Paste the real address you copied from Remix (starts with 0x)
  HAZARD_REGISTRY: '0x34c1...' // <--- Use your ACTUAL address here
};

// 3. ABIs (The Interface Rules)
export const ABIS = {
  GUARD_TOKEN: [
    // Standard ERC20 Read Functions
    "function name() view returns (string)",
    "function symbol() view returns (string)",
    "function balanceOf(address owner) view returns (uint256)",
    "function decimals() view returns (uint8)",

    // Standard ERC20 Write Functions
    "function transfer(address to, uint256 amount) returns (bool)",
    "function approve(address spender, uint256 amount) returns (bool)",

    // ✅ THE MISSING PIECE: The Faucet Function
    "function faucet() external", 

    // Events
    "event Transfer(address indexed from, address indexed to, uint256 value)",
    "event Approval(address indexed owner, address indexed spender, uint256 value)"
  ],
  
  HAZARD_REGISTRY: [
    "function reportHazard(string memory _hazardType, int256 _lat, int256 _lng, uint256 _stakeAmount) external",
    "function upvoteHazard(uint256 _reportId) external",
    "function reportCount() view returns (uint256)",
    "function reports(uint256) view returns (uint256 id, address reporter, string hazardType, int256 lat, int256 lng, uint256 timestamp, uint256 voteCount, bool verified, uint256 stakeAmount)",
    "event HazardReported(uint256 id, address reporter, string hazardType, int256 lat, int256 lng)"
  ]
};